import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetProtectedAreasInputDto, ProtectedAreaCreateDto, ProtectedAreaDto, ProtectedAreaExcelDownloadDto, ProtectedAreaUpdateDto } from '../dtos/protected-area/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ProtectedAreaService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: ProtectedAreaCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaDto>({
      method: 'POST',
      url: '/api/geographic/protectedAreas',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/protectedAreas/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/protectedAreas',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaDto>({
      method: 'GET',
      url: `/api/geographic/protectedAreas/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/protectedAreas/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetProtectedAreasInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ProtectedAreaDto>>({
      method: 'GET',
      url: '/api/geographic/protectedAreas',
      params: { name: input.name, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, propertyLocationId: input.propertyLocationId, conservationTypeId: input.conservationTypeId, recordNumber: input.recordNumber, recordNumberFrom: input.recordNumberFrom, recordNumberTo: input.recordNumberTo, officialArea: input.officialArea, officialAreaFrom: input.officialAreaFrom, officialAreaTo: input.officialAreaTo, isDinamaProtected: input.isDinamaProtected, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ProtectedAreaExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/protectedAreas/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, propertyLocationId: input.propertyLocationId, conservationTypeId: input.conservationTypeId, recordNumber: input.recordNumber, recordNumberFrom: input.recordNumberFrom, recordNumberTo: input.recordNumberTo, officialArea: input.officialArea, officialAreaFrom: input.officialAreaFrom, officialAreaTo: input.officialAreaTo, isDinamaProtected: input.isDinamaProtected, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaDto[]>({
      method: 'GET',
      url: '/api/geographic/protectedAreas/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ProtectedAreaUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaDto>({
      method: 'PUT',
      url: `/api/geographic/protectedAreas/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}